import { useGetManagerQuery } from "src/graphql/generated/queries";
import { type ManagerFragment } from "src/graphql/generated/types";

import { useUuid } from "./useUuid";

export const useGetManager = (): ManagerFragment | undefined | null => {
  const uuid = useUuid();
  const { data } = useGetManagerQuery({ uuid });

  return data?.account?.manager;
};
